import styled from 'styled-components';
const CampaignEquityStyled = styled.div`
  .coupon {
    font-size: 14px;
    color: #000;
  }
  
  .MuiFormControlLabel-label {
    font-size: 14px;
    color: #000;
  }
  .red {
    color: #ff0000;
  }
  .Pagination{
    color: #1565C0;
    width: 100%;
  }
  .desc {
    margin-top: 16px;
    color: #c9c9c9;
    font-size: 14px;
  }
  .MuiFormControlLabel-root {
    height: 14px;
  }
  .table{
    width:100%;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    .table-title{
      padding: 0 24px;
      background: #F6F6F6;
      border-radius: 4px;
      display:flex;
      height:48px;
      display:flex;
      gap:22px;
      align-items:center;
      >div{
        text-align:center;
        &:last-child{
          width: 100px;
          /* color:#1565C0; */
          text-align: right;
          padding-right: 7px;
        }
      }
      >div:nth-child(1) {
        width: 100px;
        text-align: left;
      }
      >div:nth-child(2) {
        width: 257px;
        text-align: left;
      }
      >div:nth-child(3) {
        flex: 1;
        text-align: left;
      }
      >div:nth-child(4) {
        width: 100px;
        text-align: right;
      }
      div:nth-child(5) {
        width: 180px;
        text-align: right;
      }
    }
  }
  .table-content{
    padding: 0 24px;
    /* padding-left:42px; */
    .table-row{
      min-height:48px;
      display:flex;
      gap:22px;
      border-bottom:1px solid  #DDDDDD;
      /* justify-content:space-between; */
      align-items:center;
      .subTitle{
        min-width:130px;
      }
      .delete{
        display:flex;
        justify-content:flex-end;
      }
      .coupon {
      fill: #1565c0;
    }
    .noCoupon {
      fill: #c9c9c9;
    }
    .coupon-num {
      color: #1565c0;
    }
    .noCoupon-num {
      color: #c9c9c9;
    }
    .action > div{
      /* width: 120px; */
      .MuiTextField-root{
       height:28px;
      }
      display:flex;
      align-items:center;
      justify-content: center;
      .hXAOkb{
        height:18px;
      }
    }
    .edit{
      width: 40px;
      height: 28px;
      /* background: #666464; */
      background: #1565C0;
      color:white;
      border-radius: 4px;
      font-size: 14px;
      font-family: SourceHanSansCN;
      display:flex;
      justify-content:center;
      align-items:center;
      font-weight: 400;
      cursor: pointer;
      margin-left: ${(props) => props.theme.spacing(6 / 8)};
    }
      >div{
        &:last-child{
          width: 100px;
          text-align:center;
          text-align: right;
        }
        
      }
      >div:nth-child(1) {
        width: 100px;
        text-align: left;
      }
      >div:nth-child(2) {
        width: 257px;
        text-align: left;
      }
      >div:nth-child(3) {
        flex: 1;
        text-align: left;
      }
      >div:nth-child(4) {
        width: 100px;
        text-align: right;
      }
      >div:nth-child(5) {
        width: 180px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        flex-direction: column;
      }
    }
     
  }
  .level-title-wrap {
    width: 720px;
    height: 48px;
    line-height: 48px;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    background: #f6f6f6;
    border-radius: 4px;
    padding: 0 42px;
    div:last-of-type {
      color: #1565c0;
    }
  }
  .level-content {
    width: 720px;
    border: 1px solid red;
    height: 48px;
    line-height: 48px;
    border-bottom: lpx solid #dddddd;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: 400;
    color: #000000;
    }

    .MuiOutlinedInput-root {
      height: 24px !important;
      margin-right: 0 !important;
      margin: auto;
    }
    .MuiInputBase-input {
      width: 60px;
      text-align: center !important;
    }
    .basic-name {
      /* width: 60px; */
      /* height: 24px !important; */
      background: #ffffff;
      margin-right: 0 !important;
      margin: auto;
      /* border: 2px solid #C9C9C9; */
    }
  }
`;
export default CampaignEquityStyled;
